module.exports = __webpack_public_path__ + "img/injective-4.36946f3d.webp";